module.exports = __webpack_public_path__ + "img/mate-card_simm.9da0a42.png";